export default __webpack_public_path__ + "static/media/remove.6fb9a0e2.svg";